import { css } from '@emotion/react';

export const global = css`
  scroll-behavior: smooth;

  a {
    text-decoration: none !important;
  }
`;
